import React, { useState, useEffect } from 'react';
// import ComunicacionModel from '../../models/ComunicacionModel'; // Descomentar cuando esté listo
// import ClienteModel from '../../models/ClienteModel'; // Descomentar cuando esté listo
import api from '../../services/api';
import './AdminCorreos.css';

const AdminCorreos = () => {
    const [comunicaciones, setComunicaciones] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showEnvioForm, setShowEnvioForm] = useState(false);
    const [showDetalles, setShowDetalles] = useState(null);
    const [stats, setStats] = useState({});
    const [formData, setFormData] = useState({
        cliente_id: '',
        asunto: '',
        mensaje: '',
        tipo: 'manual'
    });

    useEffect(() => {
        cargarDatos();
    }, []);

    const cargarDatos = async () => {
        setLoading(true);
        try {
            // Lógica real para cuando tus modelos estén conectados:
            // const [comunicacionesData, clientesData, statsData] = await Promise.all([
            //     ComunicacionModel.getAll(),
            //     ClienteModel.getNewsletter(),
            //     ComunicacionModel.getStats()
            // ]);
            // setComunicaciones(comunicacionesData);
            // setClientes(clientesData);
            // setStats(statsData);
            
            throw new Error("Forzando el uso de Mock Data para desarrollo visual");
            
        } catch (error) {
            console.warn('Usando datos de prueba (Mock) para el módulo de Correos:', error.message);
            // 🔥 Red de Seguridad: Datos de Prueba
            setClientes([
                { id: 1, nombre: 'Juan Pérez', email: 'juan@example.com' },
                { id: 2, nombre: 'María López', email: 'maria@example.com' },
                { id: 3, nombre: 'Carlos Ruiz', email: 'carlos@example.com' }
            ]);
            setComunicaciones([
                { id: 101, tipo: 'confirmacion_pedido', asunto: 'Tu pedido VNT-00101 ha sido confirmado', cliente_nombre: 'Roberto Sánchez', cliente_email: 'roberto@example.com', fecha: '2026-05-13T09:30:00Z', estado: 'enviado', mensaje: 'Hola Roberto, gracias por tu compra. Tu pedido está en preparación.' },
                { id: 102, tipo: 'promocion', asunto: '20% OFF en Café Altura', cliente_nombre: 'Todos (Newsletter)', cliente_email: 'Múltiples (145)', fecha: '2026-05-10T15:00:00Z', estado: 'enviado', mensaje: 'Aprovecha este mes de Mayo con nuestro descuento especial...' },
                { id: 103, tipo: 'manual', asunto: 'Problema con tu dirección de envío', cliente_nombre: 'Ana Martínez', cliente_email: 'ana@example.com', fecha: '2026-05-12T11:45:00Z', estado: 'fallido', mensaje: 'Hola Ana, la paquetería nos indica que tu código postal es incorrecto.' }
            ]);
            setStats({
                total_enviados: 1250,
                tasa_apertura: '45.2%',
                tasa_click: '12.8%',
                clientes_suscritos: 850
            });
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleEnviarCorreo = async (e) => {
        e.preventDefault();
        try {
            // Lógica Real:
            // await ComunicacionModel.send(formData);
            
            // Simulación:
            setComunicaciones([{
                id: Date.now(),
                tipo: formData.tipo,
                asunto: formData.asunto,
                cliente_nombre: formData.cliente_id === '' ? 'Todos (Newsletter)' : clientes.find(c => c.id.toString() === formData.cliente_id)?.nombre,
                cliente_email: formData.cliente_id === '' ? 'Múltiples' : clientes.find(c => c.id.toString() === formData.cliente_id)?.email,
                fecha: new Date().toISOString(),
                estado: 'pendiente',
                mensaje: formData.mensaje
            }, ...comunicaciones]);

            alert('✅ Correo encolado para envío exitosamente.');
            setShowEnvioForm(false);
            setFormData({ cliente_id: '', asunto: '', mensaje: '', tipo: 'manual' });
            
            // Simulamos que se envió después de 2 segundos
            setTimeout(() => {
                setComunicaciones(prev => prev.map(c => c.estado === 'pendiente' ? { ...c, estado: 'enviado' } : c));
            }, 2000);

        } catch (error) {
            console.error('Error enviando correo:', error);
            alert('❌ Error al enviar correo');
        }
    };

    const handleReenviar = (correo) => {
        if(window.confirm(`¿Reenviar el correo "${correo.asunto}" a ${correo.cliente_email}?`)) {
            alert('✅ Correo reenviado con éxito.');
        }
    };

    const getTipoLabel = (tipo) => {
        const tipos = {
            'manual': '📝 Manual',
            'promocion': '🎁 Promoción',
            'confirmacion_pedido': '🛍️ Conf. Pedido',
            'confirmacion_tour': '🎫 Conf. Tour'
        };
        return tipos[tipo] || tipo;
    };

    const getEstadoBadge = (estado) => {
        return <span className={`status-pill ${estado}`}>{estado}</span>;
    };

    const formatearFecha = (fecha) => {
        return new Date(fecha).toLocaleString('es-MX', {
            day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
        });
    };

    if (loading) {
        return (
            <div className="admin-loading-screen">
                <div className="coffee-spinner">📧</div>
                <p>Conectando con el servidor de correos...</p>
            </div>
        );
    }

    return (
        <div className="admin-page-container">
            <div className="admin-header-flex">
                <div>
                    <h1>📧 Centro de Comunicaciones</h1>
                    <p>Gestiona los correos, promociones y notificaciones para tus clientes.</p>
                </div>
                <button 
                    onClick={() => setShowEnvioForm(!showEnvioForm)} 
                    className={`btn-action ${showEnvioForm ? 'danger' : 'primary'}`}
                >
                    {showEnvioForm ? '✖ Cancelar' : '+ Redactar Correo'}
                </button>
            </div>

            {/* Estadísticas de Email Marketing */}
            <div className="stats-grid" style={{ marginBottom: '2rem' }}>
                <div className="stat-card">
                    <div className="stat-icon-wrapper deliveries">📨</div>
                    <div className="stat-info">
                        <h3>Correos Enviados</h3>
                        <p className="stat-number">{stats.total_enviados || 0}</p>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon-wrapper success">👁️</div>
                    <div className="stat-info">
                        <h3>Tasa de Apertura</h3>
                        <p className="stat-number">{stats.tasa_apertura || '0%'}</p>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon-wrapper info">🔗</div>
                    <div className="stat-info">
                        <h3>Tasa de Click (CTR)</h3>
                        <p className="stat-number">{stats.tasa_click || '0%'}</p>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon-wrapper tours">👥</div>
                    <div className="stat-info">
                        <h3>Suscritos al Newsletter</h3>
                        <p className="stat-number">{stats.clientes_suscritos || 0}</p>
                    </div>
                </div>
            </div>

            {/* Formulario de Redacción */}
            {showEnvioForm && (
                <div className="admin-form-card email-form-card">
                    <h2>✉️ Redactar Nuevo Correo</h2>
                    <form onSubmit={handleEnviarCorreo}>
                        <div className="form-grid-layout email-grid">
                            <div className="form-group">
                                <label>Destinatario *</label>
                                <select name="cliente_id" value={formData.cliente_id} onChange={handleInputChange}>
                                    <option value="">👥 Todos los clientes suscritos (Newsletter)</option>
                                    {clientes.map(cliente => (
                                        <option key={cliente.id} value={cliente.id}>
                                            👤 {cliente.nombre} - {cliente.email}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group">
                                <label>Categoría del Correo *</label>
                                <select name="tipo" value={formData.tipo} onChange={handleInputChange}>
                                    <option value="manual">📝 Correo Manual (General)</option>
                                    <option value="promocion">🎁 Anuncio de Promoción</option>
                                    <option value="confirmacion_pedido">🛍️ Seguimiento de Pedido</option>
                                    <option value="confirmacion_tour">🎫 Aviso sobre Tours</option>
                                </select>
                            </div>

                            <div className="form-group full-width">
                                <label>Asunto del Correo *</label>
                                <input
                                    type="text"
                                    name="asunto"
                                    value={formData.asunto}
                                    onChange={handleInputChange}
                                    placeholder="Ej: ¡Oferta especial de fin de semana para ti!"
                                    required
                                />
                            </div>

                            <div className="form-group full-width">
                                <label>Mensaje *</label>
                                <div className="editor-simulado">
                                    <div className="editor-toolbar">
                                        <button type="button"><b>B</b></button>
                                        <button type="button"><i>I</i></button>
                                        <button type="button"><u>U</u></button>
                                        <span className="toolbar-divider"></span>
                                        <button type="button">🔗 Link</button>
                                        <button type="button">🖼️ Imagen</button>
                                    </div>
                                    <textarea
                                        name="mensaje"
                                        value={formData.mensaje}
                                        onChange={handleInputChange}
                                        rows="10"
                                        placeholder="Escribe el contenido de tu correo aquí. Puedes usar HTML básico si lo necesitas."
                                        required
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-actions" style={{ marginTop: '1.5rem' }}>
                            <button type="submit" className="btn-action primary" style={{ width: '100%', padding: '1rem' }}>
                                🚀 Enviar Correo Ahora
                            </button>
                        </div>
                    </form>
                </div>
            )}

            {/* Historial de correos (Tabla) */}
            <div className="admin-section-divider">
                <h2>🗂️ Historial de Comunicaciones</h2>
            </div>
            
            <div className="table-wrapper">
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Tipo</th>
                            <th>Asunto</th>
                            <th>Destinatario</th>
                            <th>Fecha de Envío</th>
                            <th>Estado</th>
                            <th className="text-right">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {comunicaciones.length === 0 && (
                            <tr><td colSpan="7" className="empty-state">No hay correos en el historial.</td></tr>
                        )}
                        
                        {comunicaciones.map(com => (
                            <React.Fragment key={com.id}>
                                <tr className={showDetalles === com.id ? 'row-expanded-active' : ''}>
                                    <td className="fw-bold text-muted">#{com.id}</td>
                                    <td>
                                        <span className="tipo-correo-tag">{getTipoLabel(com.tipo)}</span>
                                    </td>
                                    <td><strong>{com.asunto}</strong></td>
                                    <td>
                                        <div className="direccion-cell">
                                            <span>{com.cliente_nombre}</span>
                                            <small>{com.cliente_email}</small>
                                        </div>
                                    </td>
                                    <td>{formatearFecha(com.fecha)}</td>
                                    <td>{getEstadoBadge(com.estado)}</td>
                                    <td>
                                        <div className="acciones-flex">
                                            <button 
                                                className="btn-icon-action" 
                                                title="Ver Contenido"
                                                onClick={() => setShowDetalles(showDetalles === com.id ? null : com.id)}
                                            >
                                                {showDetalles === com.id ? '🔽' : '👁️'}
                                            </button>
                                            <button 
                                                className="btn-icon-action" 
                                                title="Reenviar este correo"
                                                onClick={() => handleReenviar(com)}
                                            >
                                                🔄
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                
                                {/* Fila Expandible para ver el mensaje */}
                                {showDetalles === com.id && (
                                    <tr className="row-expanded-details">
                                        <td colSpan="7">
                                            <div className="correo-preview-box">
                                                <div className="correo-preview-header">
                                                    <strong>De:</strong> contacto@romanvalderrabano.com <br/>
                                                    <strong>Para:</strong> {com.cliente_email} <br/>
                                                    <strong>Asunto:</strong> {com.asunto}
                                                </div>
                                                <div className="correo-preview-body">
                                                    {com.mensaje || 'Sin contenido de texto.'}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminCorreos;